import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Login from "./Login";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import VerifyUsers from "./VerifyUsers";
const SigninWidget = () => {




  return (
    <div>
      <AuthenticatedTemplate>
        <VerifyUsers />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>

    </div>
  )
}

export default SigninWidget

